import { render, staticRenderFns } from "./SPRPrivateNotes.vue?vue&type=template&id=7c202cf8&scoped=true"
import script from "./SPRPrivateNotes.vue?vue&type=script&lang=js"
export * from "./SPRPrivateNotes.vue?vue&type=script&lang=js"
import style0 from "./SPRPrivateNotes.vue?vue&type=style&index=0&id=7c202cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c202cf8",
  null
  
)

export default component.exports